import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-94" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-95" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Ein Blick in deine neuen Unterrichtsmaterialien 👀" body="Entdecke echte Einblicke in die Fachbände – anschaulich, praxisnah und für den Unterricht aufbereitet." data-id="element-96" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-97" data-mp="23902aqzi4q2v">
          <InsidePagesCarousel data-id="element-98" data-mp="1y70yxh3rht5x" />
        </div>
      </div>
    </section>;
}